// Shared by the inquiry form and its API route, so both sides validate exactly the same way

import { toLatinDigits, toPersianDigits } from '@/lib/format'

export const INQUIRY_TOPICS = [
    'مشاوره خرید',
    'سفارش محصول',
    'سفارش در ابعاد و رنگ دلخواه',
    'هماهنگی بازدید از شوروم',
    'خدمات پس از فروش',
    'سایر'
] as const

export type InquiryTopic = typeof INQUIRY_TOPICS[number]

export type InquiryField = 'name' | 'phone' | 'email' | 'city' | 'topic' | 'message'

export type InquiryErrors = Partial<Record<InquiryField, string>>

export interface InquiryInput {
    name: string
    phone: string
    email: string
    city: string
    topic: string
    message: string
}

export const INQUIRY_LIMITS = {
    name: 80,
    email: 120,
    city: 60,
    option: 120,
    message: 2000
}

const PHONE_PATTERN = /^\+?\d{8,14}$/
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const normalizePhone = (value: string): string => {
    return toLatinDigits(value).replace(/[\s\-().]/g, '')
}

export const isInquiryTopic = (value: string): value is InquiryTopic => {
    return (INQUIRY_TOPICS as readonly string[]).includes(value)
}

export const validateInquiry = (input: InquiryInput): InquiryErrors => {
    const errors: InquiryErrors = {}

    const name = input.name.trim()
    if (name.length < 2) errors.name = 'لطفاً نام خود را وارد کنید.'
    else if (name.length > INQUIRY_LIMITS.name) errors.name = 'نام واردشده بیش از حد طولانی است.'

    const phone = normalizePhone(input.phone)
    if (!phone) errors.phone = 'برای تماس مشاوران، شماره تماس لازم است.'
    else if (!PHONE_PATTERN.test(phone)) errors.phone = 'شماره تماس معتبر نیست؛ مثلاً ۰۹۱۲۳۴۵۶۷۸۹'

    const email = input.email.trim()
    if (email && (email.length > INQUIRY_LIMITS.email || !EMAIL_PATTERN.test(email))) errors.email = 'نشانی ایمیل معتبر نیست.'

    if (input.city.trim().length > INQUIRY_LIMITS.city) errors.city = 'نام شهر بیش از حد طولانی است.'

    if (!isInquiryTopic(input.topic)) errors.topic = 'لطفاً موضوع درخواست را انتخاب کنید.'

    if (input.message.trim().length > INQUIRY_LIMITS.message) {
        errors.message = `توضیحات حداکثر ${toPersianDigits(INQUIRY_LIMITS.message)} نویسه می‌تواند باشد.`
    }

    return errors
}
